import { useLocalStorage } from "usehooks-ts"

import { LOCAL_STORAGE_KEYS } from "~config/constants"
import type { PortalTypeForContext } from "~contexts/outfitter-provider"

export function usePersistedPortalType(
    initialPortalType?: PortalTypeForContext
) {
    const [portalType, setPortalType] = useLocalStorage<PortalTypeForContext>(
        LOCAL_STORAGE_KEYS.MB_GLOBAL_PORTAL_TYPE,
        initialPortalType
    )

    return { portalType, setPortalType }
}
